import PlusBadge from "components/shared/PlusBadge";
import capitalize from "components/ui/utils/capitalize";
import { PLACEMENT } from "components/ui/utils/constant";
import { AIContext } from "contexts/AIContext";
import { useContext } from "react";
import { BiSolidPencil } from "react-icons/bi";
import { HiCheckCircle, HiChevronDown, HiStar } from "react-icons/hi";
import { HiPencil } from "react-icons/hi2";
import { LuPencil } from "react-icons/lu";
import { TbPencil } from "react-icons/tb";

const { Dropdown, Button, Tooltip } = require("components/ui");

const AIImageDropdownModels = ({ model, setModel, className, parentClassName, showCreditsInToggle = false, truncate = false }) => {

    const { aiImageModels, availableAiModels } = useContext(AIContext);

    const availableModels = aiImageModels?.filter(e => !e?.hidden).filter(e => !e?.disabled) || [];
    const currentModel = availableModels.find(e => e.model === model) || availableModels[0];

    if (availableModels?.length <= 1) return <></>;

    const Toggle = (
        <div className={`flex items-center justify-between gap-2 cursor-pointer ${className}`}>
            <div className="flex items-center gap-2">
                <img 
                    src={currentModel?.image} 
                    alt={currentModel?.driverDisplayName}
                    className="w-3.5 h-3.5 rounded"
                />
                <div className="flex flex-col items-start">
                    <div className="flex items-center gap-2">
                        <span className="font-normal">{truncate ? currentModel?.name?.slice(0, 8) + '...' : currentModel?.name}</span>
                        {currentModel?.best && (
                            <HiStar className="w-3 h-3 text-yellow-500" />
                        )}
                    </div>
                    {showCreditsInToggle && <span className="text-[10px] text-gray-500 -mt-0.5">{currentModel?.price} credits</span>}
                </div>
            </div>
            <HiChevronDown className="text-lg" />
        </div>
    );

    return (
        <div className={parentClassName}>
            <Dropdown
                renderTitle={Toggle}
                placement={PLACEMENT.BOTTOM_START}
                className="!w-full"
                toggleClassName="!w-full"
                menuClass="max-h-[250px] lg:max-h-[290px] overflow-y-auto !min-w-full"
            >
                {availableModels.map((modelObj) => (
                    <Dropdown.Item 
                        key={modelObj.model}
                        eventKey={modelObj.model} 
                        onSelect={() => setModel(modelObj.model)}
                        className={`flex items-center gap-3 p-3 py-2 hover:!bg-gray-100 dark:hover:!bg-gray-900/20 ${model === modelObj.model ? 'bg-pink-50 dark:bg-pink-900/20' : ''}`}
                    >
                        <img 
                            src={modelObj.image} 
                            alt={modelObj.driverDisplayName}
                            className="w-5 h-5 rounded"
                        />
                        <div className="flex-1">
                            <div className="flex items-center gap-1">
                                <div className="font-normal">{modelObj.name}</div>
                                {modelObj.allowImageEdit && (
                                    <Tooltip title="Edit images">
                                        <div className="flex items-center gap-1 shrink-0">
                                            <BiSolidPencil className="w-3 h-3 text-pink-500" />
                                        </div>
                                    </Tooltip>
                                )}
                                {modelObj.best && (
                                    <div className="flex items-center gap-1 shrink-0">
                                        <HiStar className="w-3 h-3 text-yellow-500" />
                                    </div>
                                )}
                            </div>
                            <div className="flex items-center gap-2">
                                <span className="text-[10px] font-normal opacity-70">{modelObj.price} credits</span>
                            </div>
                        </div>
                    </Dropdown.Item>
                ))}
            </Dropdown>
        </div>
    );
}

export default AIImageDropdownModels;